export default function setCookie(
  name,
  value
  // , expires
) {
  document.cookie = `${name}=${encodeURIComponent(value) || ""}; path=/`;
}
